module.exports = __webpack_public_path__ + "img/Ebra-Logo.06e5d4fa.png";